import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';
import { BulkReviewOrchestrator } from './BulkReviewOrchestrator';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PendingChangesWidget = () => {
    const { token, isCliente } = useAuth();
    const navigate = useNavigate();
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [showReviewModal, setShowReviewModal] = useState(false);

    useEffect(() => {
        if (!token || isCliente()) {
            setLoading(false);
            return;
        }
        fetchPendingCount();
    }, [token, isCliente]);

    async function fetchPendingCount() {
        try {
            const res = await axios.get(`${API}/trademarks?has_pending_changes=true`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCount(res.data?.length || 0);
        } catch (error) {
            console.error("Error fetching pending changes:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleTrademarkProcessed = useCallback(() => {
        setCount(prev => Math.max(0, prev - 1));
    }, []);

    if (loading || count === 0 || isCliente()) return null;

    return (
        <>
            <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 mb-6 flex flex-col sm:flex-row items-start sm:items-center justify-between shadow-sm gap-4">
                <div className="flex items-center gap-4">
                    <div className="bg-indigo-100 p-2 rounded-full flex-shrink-0">
                        <AlertTriangle className="h-6 w-6 text-indigo-600" />
                    </div>
                    <div>
                        <h3 className="font-semibold text-indigo-900 text-lg">
                            {count} {count === 1 ? 'marca requiere' : 'marcas requieren'} aprobación
                        </h3>
                        <p className="text-indigo-700 text-sm">
                            Se han detectado cambios en la sincronización con el IMPI que necesitan tu revisión.
                        </p>
                    </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 items-center w-full sm:w-auto">
                    <button
                        onClick={() => navigate('/trademarks?pending_changes=true')}
                        className="text-sm text-indigo-700 hover:text-indigo-900 font-medium underline-offset-4 hover:underline whitespace-nowrap"
                    >
                        Ver lista completa
                    </button>
                    <Button
                        className="bg-indigo-600 hover:bg-indigo-700 text-white whitespace-nowrap w-full sm:w-auto shadow-md"
                        onClick={() => setShowReviewModal(true)}
                    >
                        Revisar {count} cambios ahora <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                </div>
            </div>

            <BulkReviewOrchestrator
                isOpen={showReviewModal}
                onClose={() => {
                    setShowReviewModal(false);
                    fetchPendingCount();
                }}
                onComplete={() => {
                    setShowReviewModal(false);
                    fetchPendingCount(); // Refresh count after reviewing
                }}
                onTrademarkProcessed={handleTrademarkProcessed}
            />
        </>
    );
};
